<template>
    <div ref="collapsibles" id="accordion_project_settings" class="lb-accordion pt-1">

        <!-- General information -->
        <article class="message">
            <div class="message-header has-text-black">
                <a href="#collapsible-message-accordion-information" data-action="collapse" style="width: 100%"
                    :ref="'information'" >
                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <div class="level-item section-title">
                                    <span class="icon-text">
                                        <span class="icon is-medium">
                                            <i class="
                                                    mdi
                                                    mdi-24px
                                                    mdi-information-outline
                                                "></i>
                                        </span>
                                        <span class="ml-2 mt-1">
                                            {{
                                                $t(
                                                    'project.settings.general_information'
                                                )
                                            }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                    </nav>
                </a>
            </div>
            <div id="collapsible-message-accordion-information" class="message-body is-collapsible project-settings"
                data-parent="accordion_project_settings" data-allow-multiple="false">
                <div class="message-body-content px-2 py-2">
                    <l-project-configuration-fields v-model="project" :can-edit="canEdit" :is-admin="hasAdminPermission" />
                </div>
            </div>
        </article>
        <!-- Descriptive image -->
        <article class="message">
            <div class="message-header has-text-black">
                <a href="#collapsible-message-accordion-image" data-action="collapse" style="width: 100%" :ref="'image'"
                    >
                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <div class="level-item section-title">
                                    <span class="icon-text">
                                        <span class="icon is-medium">
                                            <i class="
                                                    mdi
                                                    mdi-24px
                                                    mdi-image-outline
                                                "></i>
                                        </span>
                                        <span class="ml-2 mt-1">
                                            {{
                                                $t(
                                                    'project.settings.descriptive_image'
                                                )
                                            }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                    </nav>
                </a>
            </div>
            <div id="collapsible-message-accordion-image" class="message-body is-collapsible project-settings"
                data-parent="accordion_project_settings" data-allow-multiple="false">
                <div class="message-body-content px-2 py-2">
                    <div class="columns is-marginless is-mobile is-multiline">
                        <div class="column is-12">
                            <!--<p
                                v-t="'project.settings.project_main_image'"
                                class="
                                    label
                                    has-text-black has-text-weight-bold
                                    mb-0
                                "
                            />-->
                            <p class="is-size-7 is-italic has-text-grey">
                                {{
                                    $t(
                                        'project.settings.project_main_image_description'
                                    )
                                }}
                            </p>
                            <l-project-configuration-image :image.sync="project.image" :can-edit="canEdit" class="pt-4" />
                        </div>
                    </div>
                </div>
            </div>
        </article>

        <!-- Overlay image -->
        <article class="message" v-if="canSetOverlayImage">
            <div class="message-header has-text-black">
                <a href="#collapsible-message-accordion-overlay" data-action="collapse" style="width: 100%" ref="overlay"
                    >
                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <div class="level-item section-title">
                                    <span class="icon-text">
                                        <span class="icon is-medium">
                                            <i class="
                                                    mdi
                                                    mdi-24px
                                                    mdi-checkerboard
                                                "></i>
                                        </span>
                                        <span class="ml-2 mt-1">
                                            {{ $t('project.settings.overlay') }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                    </nav>
                </a>
            </div>
            <div id="collapsible-message-accordion-overlay" class="message-body is-collapsible project-settings"
                data-parent="accordion_project_settings" data-allow-multiple="false">
                <div class="message-body-content px-2 py-2">
                    <div class="columns is-marginless is-mobile is-multiline">
                        <div class="column is-12">
                            <p v-t="'project.settings.project_overlay_image'" class="label" />
                            <p class="is-size-7 is-italic has-text-grey">
                                {{
                                    $t(
                                        'project.settings.project_main_overlay_description'
                                    )
                                }}
                            </p>
                            <l-project-configuration-image :image.sync="overlayImage" :can-edit="canEdit" class="pt-4" />
                        </div>
                        <div class="column is-12" v-if="overlayImage">
                            <label class="label">{{
                                $t(
                                    'project.settings.project_overlay_image_opacity'
                                )
                            }}</label>
                            <div class="pb-4">
                                <vue-slider style="z-index: 0" v-model="project.overlay.opacity" @drag-end="
                                    $emit(
                                        'changeOpacity',
                                        project.overlay.opacity
                                    )
                                    " />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>

        <!-- Background -->
        <article class="message" v-if="canSetBackground">
            <div class="message-header has-text-black">
                <a href="#collapsible-message-accordion-images" data-action="collapse" style="width: 100%" ref="images"
                    >
                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <div class="level-item section-title">
                                    <span class="icon-text">
                                        <span class="icon is-medium">
                                            <i class="
                                                    mdi
                                                    mdi-24px
                                                    mdi-image-multiple-outline
                                                "></i>
                                        </span>
                                        <span class="ml-2 mt-1">
                                            {{ $t('project.settings.media') }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                    </nav>
                </a>
            </div>
            <div id="collapsible-message-accordion-images" class="message-body is-collapsible project-settings"
                data-parent="accordion_project_settings" data-allow-multiple="false">
                <div class="message-body-content px-2 py-2">
                    <div class="columns is-marginless is-mobile is-multiline">
                        <div class="column is-12">
                            <!--<p v-t="'project.settings.project_background_image'
                                " class="label" />-->
                            <p class="is-size-7 is-italic has-text-grey">
                                {{
                                    $t(
                                        'project.settings.project_background_image_description'
                                    )
                                }}
                            </p>
                            <project-configuration-background key="background" :background.sync="project.background"
                                :background-image.sync="project.backgroundImage" class="pt-4" />
                        </div>
                    </div>
                </div>
            </div>
        </article>

        <!-- Base map -->
        <article class="message" v-if="canSetBaseMap">
            <div class="message-header has-text-black">
                <a href="#collapsible-message-accordion-basemap" data-action="collapse" style="width: 100%" :ref="'basemap'"
                    >
                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <div class="level-item section-title">
                                    <span class="icon-text">
                                        <span class="icon is-medium">
                                            <i class="
                                                    mdi
                                                    mdi-24px
                                                    mdi-map-check-outline
                                                "></i>
                                        </span>
                                        <span class="ml-2 mt-1">{{
                                            $t('project.settings.base_map')
                                        }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                    </nav>
                </a>
            </div>
            <div id="collapsible-message-accordion-basemap" class="message-body is-collapsible project-settings"
                data-parent="accordion_project_settings" data-allow-multiple="false">
                <div class="message-body-content px-2 py-2">
                    <div class="columns is-mobile is-vcentered is-multiline is-centered">
                        <div v-for="tileProvider in availableProviders" :key="tileProvider.name" class="column is-half"
                            @click="changeProvider(tileProvider)">
                            <div class="tile-select" :class="{
                                'is-active':
                                    activeProvider == tileProvider.name,
                            }">
                                <figure class="image is-5by4">
                                    <img :src="`/img/map-providers/${tileProvider.image}`" />
                                </figure>
                                <p class="is-size-7 has-text-centered">
                                    {{ tileProvider.name }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--<div class="columns is-mobile is-vcentered px-3 py-3" v-if="isAdmin">
                        <div class="column">
                            <p
                                v-t="`use_icgc_maps`"
                                class="title is-6 mb-0"
                            ></p>
                        </div>
                        <div class="column is-3 has-text-right">
                            <label class="switch">
                                <input
                                    v-model="project.useICGC"
                                    type="checkbox"
                                />
                                <span class="slider round"></span>
                            </label>
                                
                        </div>
                    </div>-->
                </div>
            </div>
        </article>

        

        <div v-if="errorsOnSave" class="validationErrors px-5">
            <div class="notification is-danger is-light">
                <button class="delete" @click="errorsOnSave = false"></button>
                <p class="has-text-weight-bold is-size-6 pb-2">
                    {{ $t('project.errors_on_save') }}
                </p>
                <p class="is-size-6">
                    {{ $t('project.errors_on_save_desc') }}
                </p>
                <br />
                <p class="is-size-6 has-text-italic" v-for="(error, index) in projectErrors" :key="index">
                    - {{ error }}
                </p>
            </div>
        </div>

        <div class="action-buttons-container mb-2">
            <a @click="discardUnsavedChanges" class="button is-primary">
                <span class="icon is-small my-2"><i class="mdi mdi-32px mdi-chevron-double-left"
                        aria-hidden="true"></i></span>
            </a>
            <a :disabled="!hasChanges" @click="saveChanges"
                class="button is-primary primary-font is-size-5 is-pulled-right mr-5">
                {{ $t('Buttons.save') }}
            </a>
        </div>
    </div>
</template>

<script>
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import LProjectConfigurationPrivacy from '@/components/LProjectConfigurationPrivacy';
import ProjectConfigurationParticipants from '@/components/ProjectConfigurationParticipants';
import LProjectNotifications from '@/components/LProjectNotifications';
import LProjectConfigurationFields from '@/components/LProjectConfigurationFields';
import LProjectConfigurationImage from '@/components/LProjectConfigurationImage';
import ProjectConfigurationBackground from '@/components/ProjectConfigurationBackground';
import _ from 'underscore';
import VueSlider from 'vue-slider-component';

export default {
    components: {
        LProjectConfigurationPrivacy,
        ProjectConfigurationParticipants,
        LProjectNotifications,
        VueSlider,
        LProjectConfigurationFields,
        LProjectConfigurationImage,
        ProjectConfigurationBackground,
    },
    props: {
        tileProviders: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    mounted() {
        const collapsibles = bulmaCollapsible.attach('.project-settings', {allowMultiple: false});
    },
    data() {
        return {
            project: this.projectSource,
            saving: false,
            pendingChanges: false,
            errorsOnSave: false,
            projectErrors: {},
            showBackground: false,
            originalProvider: '',
            overlayImage: undefined,
            originalOverlay: { ...this.$store.state.project.overlay } || {
                image: {},
                opacity: 100,
            },

        };
    },
    computed: {
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
            // return true;
        },
        hasEditPermission() {
            return this.$store.getters.project.accessLevel == 'edit';
            // return true;
        },
        canEdit() {
            return this.hasAdminPermission || this.hasEditPermission;
            // return true;
        },
        hasChanges() {
            return (
                !_.isEqual(this.project, this.$store.state.project) ||
                !_.isEqual(this.project.mapProvider, this.originalProvider) ||
                !_.isEqual(this.project.overlay, this.originalOverlay)
            );
        },
        projectSource() {
            // console.log(this.$store.getters.project);
            const proj = this.$store.getters.project;
            if (
                this.hasAdminPermission &&
                !this.$store.getters.project.folder
            ) {
                proj.folder = {};
                //return proj;
            }
            if (!this.$store.getters.project.mapProvider) {
                proj.mapProvider = 'OpenStreetMap 2';
            }
            if (this.originalProvider == '') {
                this.originalProvider = proj.mapProvider;
            }
            if (!this.$store.getters.project.overlay) {
                // console.log('assigning default overlay');
                proj.overlay = {
                    image: {},
                    opacity: 100,
                };
            } else {
                if (
                    this.$store.getters.project.overlay.image &&
                    Object.keys(this.$store.getters.project.overlay.image)
                        .length > 0
                ) {
                    this.overlayImage =
                        this.$store.getters.project.overlay.image;
                }
            }
            return proj;
        },
        availableProviders() {
            return _.filter(this.tileProviders, (provider) => {
                return provider.image;
            });
        },
        activeProvider() {
            return this.project.mapProvider || 'OpenStreetMap 2';
        },
        canSetBackground() {
            return this.project.mode != 'map' && this.project.type != 'scape' && this.project.type != 'treasurehunt';
        },
        canSetOverlayImage() {
            return this.project.type == 'scape' && this.project.mode == 'map';
        },
        canSetBaseMap() {
            return this.project.mode == 'map' || this.project.type == 'treasurehunt';
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        }
    },
    watch: {
        projectSource: {
            handler: function () {
                this.project = JSON.parse(JSON.stringify(this.projectSource));
                // console.log('changes in project', this.project);
            },
            immediate: true,
        },
        overlayImage: {
            handler: function () {
                // console.log('change image', this.overlayImage);

                // this.project.overlayImage = this.overlayImage;
                if (
                    this.overlayImage &&
                    (!this.project.overlay || !this.project.overlay.image)
                ) {
                    // console.log('adding new overlay image');
                    this.project.overlay.image = this.overlayImage;
                    this.$emit('drawOverlayImage', this.overlayImage);
                } else if (this.overlayImage && this.project.overlay.image) {
                    // console.log('updating overlay image');
                    if (
                        !_.isEqual(
                            this.overlayImage,
                            this.project.overlay.image
                        )
                    ) {
                        this.project.overlay.image = this.overlayImage;
                        this.project.overlay.opacity = 100;
                        this.$emit('updateOverlayImage', this.overlayImage);
                    }
                } else {
                    // console.log('removing overlay image',this.overlayImage);
                    this.project.overlay.image = {};
                    this.project.overlay.opacity = 100;
                    this.$emit('removeOverlayImage', this.overlayImage);
                }
            },
        },
    },
    methods: {
        
        saveChanges() {
            // console.log('project data to save', this.project);
            if (!this.project.langs || !this.project.langs.length) {
                this.project.defaultLang = '';
                delete this.project.titlePerLang;
                delete this.project.descriptionPerLang;
            } else {
                if (this.projectErrors['defaultLang']) {
                    delete this.projectErrors['defaultLang'];
                }
                if (this.projectErrors['title']) {
                    delete this.projectErrors['title'];
                }
                if (this.projectErrors['description']) {
                    delete this.projectErrors['description']
                }
                
                if (!this.project.defaultLang) {
                    this.projectErrors['defaultLang'] = this.$t(`missing_project_default_lang`);
                }
                if (!this.project.titlePerLang || !this.project.descriptionPerLang) {
                    if (!this.project.titlePerLang) {
                        this.project.titlePerLang = {};
                        this.project.titlePerLang[this.project.defaultLang] = this.project.title;
                    }
                    if (!this.project.descriptionPerLang) {
                        this.project.descriptionPerLang = {};
                        this.project.descriptionPerLang[this.project.defaultLang] = this.project.description;
                    }
                } else if (!this.project.titlePerLang[this.project.defaultLang]) { 
                    // console.log('defaultLang', this.project.defaultLang)
                    if (this.project.title) {
                        this.project.titlePerLang[this.project.defaultLang] = this.project.title;
                    } else {
                        this.projectErrors['title'] = this.$t(`missing_project_default_lang_title`);
                    }
                    
                } else if (!this.project.descriptionPerLang[this.project.defaultLang]) { 
                    if (this.project.description) {
                        this.project.descriptionPerLang[this.project.defaultLang] = this.project.description;
                    } else {
                        this.projectErrors['description'] = this.$t(`missing_project_default_lang_description`);
                    }
                    
                }
            }
            this.saving = true;
            if (!this.project.title) {
                this.projectErrors['title'] = this.$t(
                    `project.missing_title_value`
                );
            }

            if (this.project.type == 'scape') {
                if (
                    !this.project.overlay.image ||
                    Object.keys(this.project.overlay.image).length === 0
                ) {
                    this.projectErrors['overlay'] = this.$t(
                        `project.missing_overlay_value`
                    );
                }
            }

            const isValid = Object.keys(this.projectErrors).length === 0;
            // console.log('project errors', this.projectErrors);
            if (isValid) {
                if (_.isEmpty(this.project.folder)) {
                    delete this.project.folder;
                }
                this.$emit('updateProject', this.project);
                this.saving = false;
            } else {
                this.saving = false;
                this.errorsOnSave = true;
            }
        },
        discardUnsavedChanges() {
            if (this.hasChanges) {
                // console.log('discarding changes');
                this.$emit('discardChanges');
            }
            this.$emit('close');
        },
        changeProvider(provider) {
            if (
                this.project.mapProvider !== provider.name ||
                !this.project.mapProvider
            ) {
                this.project.mapProvider = provider.name;
                this.$emit('changeTileProvider', provider);
            }
        },
    },
};
</script>

<style scoped>
@import '~vue-slider-component/theme/default.css';
@import '../assets/css/leftPanel.css';

.message {
    background-color: transparent;
    border-radius: 0;
    font-size: 1rem;
    margin-bottom: 0;
}

.message-header {
    border-radius: 0;
    padding-right: 0;
    background-color: #f4f4f4;
    border-bottom: 1px solid #d2d2d2;
}

.lb-accordion {
    overflow-y: auto;
    max-height: calc(100vh - 13rem);
    overflow-x: hidden;
}

.message a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
    text-decoration: none;
}

.message-body.is-collapsible {
    overflow-x: hidden;
}

.action-buttons {
    position: absolute;
    bottom: 11px;
    width: 100%;
    left: 10px;
}

.action-buttons button {
    height: 60px;
}

.validationErrors {
    position: absolute;
    z-index: +1;
    top: 20%;
}

.validationErrors .notification {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}


</style>